import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { NotificationService } from '../services/notification.service';

/**
 * HTTP interceptor for handling errors globally.
 * CPNotes: 401 left for refresh flow; 403 routes to access-denied
 */
export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const notificationService = inject(NotificationService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        return throwError(() => error);
      }

      if (error.status === 403) {
        const message = error.error?.detail || error.error?.message || 'You do not have permission to perform this action.';
        notificationService.error(message, 'Access Denied');
        if (!router.url.startsWith('/access-denied')) {
          void router.navigate(['/access-denied']);
        }
        return throwError(() => error);
      }

      if (error.status >= 400) {
        const message = error.error?.detail || error.error?.message || error.message || 'An error occurred';
        notificationService.error(message, 'Error');
      }

      return throwError(() => error);
    })
  );
};
